import type { Image as ImageType } from 'types/capi/shared';

import { Dialog } from '~/components/Dialog';
import Image, { smallImageOptions } from '~/components/Image';
import ModalNav from '~/components/Modals/ModalNav';

type Props = {
  children: React.ReactNode;
  heading: string;
  image?: ImageType;
  onBack?: () => void;
  onDismiss: () => void;
};

export default function ExitNotificationDialog({
  children,
  heading,
  image,
  onBack,
  onDismiss
}: Props) {
  return (
    <Dialog
      isOpen={true}
      onDismiss={onDismiss}
      className="z-50 rounded-2xl bg-white p-4 pt-6 text-black max-md:mx-4"
    >
      <div className="flex w-auto max-w-[500px] flex-col items-center justify-center gap-6 text-center">
        <ModalNav heading={heading} hideDismiss onBack={onBack} />
        {image && (
          <Image
            className="h-[45px] w-[80px] object-cover"
            src={image.url}
            alt={image.alt}
            loading="eager"
            {...smallImageOptions({ pad: true })}
          />
        )}
        {children}
      </div>
    </Dialog>
  );
}
